import { render, staticRenderFns } from "./PurchasePaymentModeDisplayView.vue?vue&type=template&id=f5363452"
import script from "./PurchasePaymentModeDisplayView.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentModeDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports